// extracted by mini-css-extract-plugin
module.exports = {"videoBox":"indexVideo_videoBox__1B_hL","video":"indexVideo_video__3Ywp_"};